import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import { SingleRedio, SingleTextArea, SingleText, SingleMultilineText } from '../../Res/BaseInput';
import { CancelSubmitButton, Space } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { RespCustomerContract, RespCustomerContractInfo, ReqCustomerContractDetail } from '../../../../item/ItemCustomerContract';
import { DatePickerInput } from 'rc-datepicker';
import moment from 'moment';
import { ItemCustomerInformation } from './ItemCustomerInformation';
import { ItemPersonnelContact } from './ItemPersonnelContact';
import { ItemAttendanceSalaryContact } from './ItemAttendanceSalaryContact';
import { ItemPaymentTerms } from './ItemPaymentTerms';
import { ItemAProjectContact } from './ItemAProjectContact';
import { ItemBProjectContact } from './ItemBProjectContact';
import { ItemAttachment } from './ItemAttachment';
import { api_addCustomerContract, api_getCustomerContractDetail } from '../../../../api/apiCustomerContract';
import { getUserInfoCompanyId, getResume2Token, getval2Token } from '../../../Login/Auth';
import { CustomerPositionList } from '../CustomerPosition/CustomerPositionList';
import { ItemCompanyInContact } from './ItemCompanyInContact';


export function CustomerContractEdit({ id, setIsLoading, isEdit, isAdd=false }) {
  const [tokenId, setTokenId] = useState("")
  const [companyId] = useState(getUserInfoCompanyId())
  const [customerContractId, setCustomerContractId] = useState("")
  const [info, setInfo] = useState({})
  const [isDisable, setIsDisable] = useState(0)
  const [isPublic, setIsPublic] = useState(0)
  const [signAt, setSignAt] = useState(moment(new Date()).format('YYYY-MM-DD'))
  const [startAt, setStartAt] = useState(moment(new Date()).format('YYYY-MM-DD'))
  const [endAt, setEndAt] = useState(moment(new Date()).format('YYYY-MM-DD'))

  const [customerInformation, setCustomerInformation] = useState("")
  const [personnelContact, setPersonnelContact] = useState("")
  const [attendanceSalaryContact, setAttendanceSalaryContact] = useState("")
  const [paymentTerms, setPaymentTerms] = useState("")
  const [jobNote, setJobNote] = useState("")
  const [note, setNote] = useState("")
  const [AProjectContact, setAProjectContact] = useState("")
  const [BProjectContact, setBProjectContact] = useState("")
  const [companyInContact, setCompanyInContact] = useState("")
  const [attachment, setAttachment] = useState([])

  const [signAtError, setSignAtError] = useState(false)
  const [startAtError, setStartAtError] = useState(false)
  const [endAtError, setEndAtError] = useState(false)

  const signAtString = '簽約日期'
  const startAtString = '派遣開始日期'
  const endAtString = '派遣結束日期'

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("customerContract", id)
      console.log(obj)
      setCustomerContractId(obj.customerContractId)
      setTokenId(id)
    }
  }, [id])

  useEffect(() => {
    if (companyId !== undefined && companyId !== "" && customerContractId !== undefined && customerContractId !== "") {
      setIsLoading(true)
      var mReqCustomerContractDetail = new ReqCustomerContractDetail({
        companyId,
        customerContractId
      })
      getDetail(mReqCustomerContractDetail)
    }
  }, [companyId, customerContractId])

  function getDetail(mReqCustomerContractDetail) {
    //console.log(mReqCustomerContractDetail)
    api_getCustomerContractDetail({
      mReqCustomerContractDetail,
      success: (jsonData) => {
        //console.log(jsonData)
        var mRespCustomerContract = new RespCustomerContract({})
        mRespCustomerContract.fromJson(jsonData.detail)
        console.log(mRespCustomerContract)

        setSignAt(moment(mRespCustomerContract.signAt).format('YYYY-MM-DD'))
        setStartAt(moment(mRespCustomerContract.startAt).format('YYYY-MM-DD'))
        setEndAt(moment(mRespCustomerContract.endAt).format('YYYY-MM-DD'))
        setIsPublic(mRespCustomerContract.isPublic)
        setIsDisable(mRespCustomerContract.isDisable)
        setInfo(mRespCustomerContract.info)
        //console.log(mRespCustomerContract.info.customerInformation)
        setCustomerInformation(mRespCustomerContract.info.customerInformation)
        setPersonnelContact(mRespCustomerContract.info.personnelContact)
        setAttendanceSalaryContact(mRespCustomerContract.info.attendanceSalaryContact)
        setPaymentTerms(mRespCustomerContract.info.paymentTerms)
        setJobNote(mRespCustomerContract.info.jobNote)
        setNote(mRespCustomerContract.info.note)
        setAProjectContact(mRespCustomerContract.info.AProjectContact)
        setBProjectContact(mRespCustomerContract.info.BProjectContact)
        setCompanyInContact(mRespCustomerContract.info.companyInContact)
        setAttachment(mRespCustomerContract.info.attachment)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function toEdit() {
    window.location.assign("/CustomerContractEdit/" + id);
  }

  function toCancel() {
    window.history.back();
  }

  function toAdd() {
    console.log(startAtError)
    console.log(paymentTerms)
    var atError = []
    if (signAtError) {
      atError.push(signAtString)
    }
    if (startAtError) {
      atError.push(startAtString)
    }
    if (endAtError) {
      atError.push(endAtString)
    }
    if (atError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: atError.join(',') + ' 格式有誤, 請確認月日為2位數',
      })
      return
    }
    var inputError = []
    if (customerInformation.companyName === "") {
      inputError.push("公司名稱")
    }
    if (customerInformation.texIdNumber === "") {
      inputError.push("公司統編")
    }
    if (inputError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: inputError.join(',') + ' 為必填',
      })
      return
    }

    var mRespCustomerContractInfo = new RespCustomerContractInfo({
      customerInformation,         //事業單位資訊
      personnelContact,         //人事聯絡窗口
      attendanceSalaryContact,  //出勤薪資聯絡窗口
      paymentTerms,                   //付款條件
      jobNote,                        //轉正服務事項
      note,                           //備註
      AProjectContact,           //甲方專案聯絡人
      BProjectContact,           //乙方專案聯絡人
      companyInContact,
      attachment,                     //附件
    })

    var mRespCustomerContract = new RespCustomerContract({
      companyId,
      customerContractId,
      info: JSON.stringify(mRespCustomerContractInfo),
      isDisable,
      isPublic,
      signAt,
      startAt,
      endAt
    })
    api_addCustomerContract({
      mRespCustomerContract,
      success: (jsonData) => {
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: isAdd?'新增成功':'修改成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
    /*
    if (departmentName !== "" && managerDepartmentId !== "") {
      var userInfo = Auth.getUserInfo()
      var mReqDepartmentAdd = new ReqDepartmentAdd({
        companyId,
        departmentName,
        managerDepartmentId,
        isDisable
      })
      api_addDepartment({
        mReqDepartmentAdd,
        success: (jsonData) => {
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '新增成功',
          }).then(function () {
            setDepartmentName("")
            setManagerDepartmentId("")
            setIsDisable(1)
            //window.history.replace("/ManagerList");
            window.history.back(-1);
          })
        },
        failure: (err) => {
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err,
          })
        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '部門名稱, 上級單位 不得為空',
      })
    }
    */
  }

  const onChangeSignAt = (jsDate, dateString) => {
    //console.log(jsDate)
    //console.log(dateString)
    if (dateString === "Invalid date") {
      setSignAtError(true)
    } else {
      setSignAtError(false)
      setSignAt(dateString)
    }
  }
  const onChangeStartAt = (jsDate, dateString) => {
    //console.log(jsDate)
    // console.log(dateString)
    if (dateString === "Invalid date") {
      setStartAtError(true)
    } else {
      setStartAtError(false)
      setStartAt(dateString)
    }
  }
  const onChangeEndAt = (jsDate, dateString) => {
    //console.log(jsDate)
    //console.log(dateString)
    if (dateString === "Invalid date") {
      setEndAtError(true)
    } else {
      setEndAtError(false)
      setEndAt(dateString)
    }
  }

  const isDisableItems = [
    { "val": 0, "name": "是" },
    { "val": 1, "name": "否" },
  ]

  const isPublicItems = [
    { "val": 1, "name": "是" },
    { "val": 0, "name": "否" },
  ]

  var title = "合約資訊"
  var title_tools =
    <a className="dropdown-toggle " onClick={e => toEdit()} data-toggle="dropdown" href="#A">
      <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">編輯</span>
    </a>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>合約期間</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleRedio title={"是否啟用"}
                arr={isDisableItems}
                val={isDisable ? 1 : 0}
                action={setIsDisable}
              />
              :
              <SingleText title={"是否啟用"} val={isDisable ? "否" : "是"} />
          }
          {
            isEdit ?
              <div className="col-md-3">
                <p>{signAtString}</p>
                <DatePickerInput
                  displayFormat='YYYY/MM/DD'
                  returnFormat='YYYY-MM-DD'
                  onChange={onChangeSignAt}
                  value={signAt}
                  className='my-react-component'
                />
              </div>
              :
              <SingleText title={signAtString} val={signAt} />
          }
        </div>
      </div>
      <Space />
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleRedio title={"是否共補"}
                arr={isPublicItems}
                val={isPublic ? 1 : 0}
                action={setIsPublic}
              />
              :
              <SingleText title={"是否共補"} val={isPublic ? "是" : "否"} />
          }
          {
            isEdit ?
              <div className="col-md-3">
                <p>{startAtString}</p>
                <DatePickerInput
                  displayFormat='YYYY/MM/DD'
                  returnFormat='YYYY-MM-DD'
                  onChange={onChangeStartAt}
                  value={startAt}
                  className='my-react-component'
                />
              </div>
              :
              <SingleText title={startAtString} val={startAt} />
          }
          {
            isEdit ?
              <div className="col-md-3">
                <p>{endAtString}</p>
                <DatePickerInput
                  displayFormat='YYYY/MM/DD'
                  returnFormat='YYYY-MM-DD'
                  onChange={onChangeEndAt}
                  value={endAt}
                  className='my-react-component'
                />
              </div>
              :
              <SingleText title={endAtString} val={endAt} />
          }
        </div>
      </div>
      <Space />
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-2">
            <p>特別注意</p>
          </div>
          <div className="col-md-10">
            <strong>日期的改變影響甚鉅，不可隨便改變！！！！！   </strong>
          </div>
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <ItemCustomerInformation item={customerInformation} action={setCustomerInformation} isEdit={isEdit} />
      <div className="hr-line-dashed"></div>
      <ItemPersonnelContact item={personnelContact} action={setPersonnelContact} isEdit={isEdit} />
      <div className="hr-line-dashed"></div>
      <ItemAttendanceSalaryContact item={attendanceSalaryContact} action={setAttendanceSalaryContact} isEdit={isEdit} />
      <div className="hr-line-dashed"></div>
      <ItemPaymentTerms item={paymentTerms} action={setPaymentTerms} isEdit={isEdit} />
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleTextArea title={"轉正服務事項"} val={jobNote} action={setJobNote} rows={5} />
              :
              <SingleMultilineText title={"轉正服務事項"} val={jobNote} size={12} />
          }
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          {
            isEdit ?
              <SingleTextArea title={"備註"} val={note} action={setNote} rows={5} />
              :
              <SingleMultilineText title={"備註"} val={note} size={12} />
          }
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <ItemAProjectContact item={AProjectContact} action={setAProjectContact} isEdit={isEdit} />
      <div className="hr-line-dashed"></div>
      <ItemBProjectContact item={BProjectContact} action={setBProjectContact} isEdit={isEdit} />
      <div className="hr-line-dashed"></div>
      <ItemCompanyInContact item={companyInContact} action={setCompanyInContact} isEdit={isEdit} />
      <div className="hr-line-dashed"></div>
      <ItemAttachment item={attachment} action={setAttachment} isEdit={isEdit} />
    </>

  var footer =
    <div className="row">
    {
      !isEdit ? <></> :
        <div className="col-sm-3 col-sm-offset-9">
          <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
        </div>
    }
    </div>

  return (
    <>
      <ContentBox title={title} title_tools={title_tools} content={content} footer={footer} hasDrawer={false} />
      {isEdit ? <></> :
        <CustomerPositionList id={tokenId} />
      }
      <SystemPromptInput />
    </>
  )
}